<template>
  <div>
    <div
      class="form-group expenses-box"
      v-for="(travelExpense, index) in travelExpensees" :key="index"
    >
      <h4>Route {{ index + 1 }}</h4>
      <div class="detail-text">
        <span class="sub-text">University/Campus：</span>
        {{ travelExpense.campus.name }}
      </div>
      <div class="detail-text">
        <span class="sub-text">Commuting Route：</span>
        {{ travelExpense.route }}
      </div>
      <div class="detail-text">
        <span class="sub-text">Nearest Station：</span>
        {{ travelExpense.nearestStation }}
      </div>
      <div class="detail-text">
        <span class="sub-text">Transportation Cost (One-Way)：</span>
        {{ travelExpense.fee }}円
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Tutor } from '@/store/tutors/types'

@Component
export default class TutorProfileTravelExpenses extends Vue {
  @Prop({ required: true }) tutor!: Tutor

  private get travelExpensees() {
    return this.tutor.travelExpenses
  }
}
</script>

<style lang="scss" scoped>
.expenses-box {
  margin-bottom:40px;

  .sub-text {
    color: #000;
  }

  .detail-text {
    margin-bottom:10px;
  }
}
</style>
